module.exports = __webpack_public_path__ + "img/citya.166c0d06.jpg";